import React from 'react';

import { Row, RowCell } from '@xarvio/layout';
import { InputControl } from '@xarvio/input';
import { useIntl } from 'react-intl';

interface Props {
  emailControlName?: string;
}

export const EmailInputField: React.FC<React.PropsWithChildren<Props>> = ({
  emailControlName = 'email',
}) => {
  const intl = useIntl();

  return (
    <Row>
      <RowCell>
        <InputControl
          controlName={emailControlName}
          name={emailControlName}
          withFormError
          width={300}
          placeholder={intl.formatMessage({
            id: 'general.emailAddress',
          })}
          seleniumAttribute={'login-email-input'}
          theme={'grey'}
          iconName={'envelope'}
          tooltipPlacement="right"
        />
      </RowCell>
    </Row>
  );
};
